<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>投资机构简介</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-button @click="addDataNew" type="primary" v-if="isInvest">新增</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>

          <el-select
            v-model="approvalStatus"
            placeholder="请选择审核状态"
            clearable
            style="display: block;width: 200px;"
            @change="searchSelect"
          >
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="3"></el-option>
            <el-option label="通过" :value="4"></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column label="机构名称" align="center" prop="orgName"></el-table-column>
            <el-table-column label="logo" align="center" prop="imgSrc" width="200px">
              <template slot-scope="{ row }">
                <el-image style="width: 200px; height: 100px" :src="row.imgSrc" fit="contain" />
              </template>
            </el-table-column>
            <el-table-column
              label="机构简称"
              align="center"
              prop="orgAbbreviation"
            ></el-table-column>
            <el-table-column
              label="成立时间"
              align="center"
              prop="orgEstablishmentDate"
            ></el-table-column>
            <el-table-column
              label="投资阶段"
              align="center"
              prop="investmentStageName"
            ></el-table-column>
            <el-table-column label="机构地址" align="center" prop="orgAbbreviation">
              <template slot-scope="{ row }">
                <div>{{ row.orgProvince }} {{ row.orgCity }} {{ row.orgDistrict }}</div>
              </template>
            </el-table-column>
            <el-table-column label="联系人" align="center" prop="contactPerson"></el-table-column>
            <el-table-column label="联系方式" align="center" prop="contactInfo"></el-table-column>
            <el-table-column label="是否发布" align="center" prop="publishedFlag">
              <template slot-scope="{ row }">
                <div v-if="row.publishedFlag === 0">未发布</div>
                <div v-if="row.publishedFlag === 1">已发布</div>
              </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center" prop="approvalStatus">
              <template slot-scope="{ row }">
                <div v-if="row.approvalStatus === 1">待审核</div>
                <div v-if="row.approvalStatus === 2">不通过</div>
                <div v-if="row.approvalStatus === 3">退回</div>
                <div v-if="row.approvalStatus === 4">通过</div>
              </template>
            </el-table-column>

            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="
                    (scope.row.approvalStatus === 1 && isInvest) ||
                      (scope.row.approvalStatus === 3 && isInvest)
                  "
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDetail(scope.$index, scope.row)"
                >
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="Title"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="机构名称" prop="orgName">
              <el-input
                v-model="ruleForm.orgName"
                placeholder="请输入机构名称"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简称" prop="orgAbbreviation">
              <el-input
                v-model="ruleForm.orgAbbreviation"
                placeholder="请输入机构简称"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="成立时间" prop="orgEstablishmentDate">
              <el-date-picker
                v-model="ruleForm.orgEstablishmentDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="请选择成立时间"
                style="text-align: left;width:100%"
                clearable
                :disabled="isDetail"
              ></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="投资阶段" prop="investmentStage">
              <el-select
                v-model="ruleForm.investmentStage"
                placeholder="请选择投资阶段"
                clearable
                style="display: block;"
                :disabled="isDetail"
              >
                <el-option
                  :label="item.label"
                  :value="Number(item.value)"
                  v-for="item in investmentList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="机构类型" prop="orgType">
              <el-select
                v-model="ruleForm.orgType"
                placeholder="请选择机构类型"
                clearable
                style="display: block;"
                :disabled="isDetail"
                @change="orgTypeChange"
              >
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="item in orgTypeList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-form-item label="投资领域" prop="investmentAreas">
              <el-select
                v-model="ruleForm.investmentAreas"
                placeholder="请选择投资领域"
                clearable
                multiple
                style="display: block;"
                :disabled="isDetail"
                @clear="clearInvest"
              >
                <el-option label="新能源" :value="'新能源'"></el-option>
                <el-option label="现代农业" :value="'现代农业'"></el-option>
                <el-option label="生物医药" :value="'生物医药'"></el-option>
                <el-option label="文化旅游" :value="'文化旅游'"></el-option>
                <el-option label="通道物流" :value="'通道物流'"></el-option>
                <el-option label="军民融合" :value="'军民融合'"></el-option>
                <el-option label="数据信息" :value="'数据信息'"></el-option>
                <el-option label="装备制造" :value="'装备制造'"></el-option>
                <el-option label="新材料" :value="'新材料'"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构地址" prop="orgProvince">
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected"
                :province="ruleForm.orgProvince"
                :city="ruleForm.orgCity"
                :area="ruleForm.orgDistrict"
                :disabled="isDetail"
              ></v-distpicker>
            </el-form-item>
            <el-form-item prop="orgAddress">
              <el-input
                v-model="ruleForm.orgAddress"
                placeholder="请填写详细地址"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简介" prop="orgDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入机构简介"
                v-model="ruleForm.orgDescription"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                placeholder="请输入联系人"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="contactInfo">
              <el-input
                v-model="ruleForm.contactInfo"
                placeholder="请输入联系方式"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="logo" prop="logoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="logoSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDetail"
                :limit="limit"
                ref="upload0"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'logoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDetail"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'logoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload1 && !isDetail">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="实景图" prop="realImageSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="realImageSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDetail"
                :limit="limit"
                ref="upload1"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'realImageSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDetail"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'realImageSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload2 && !isDetail">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>

          <el-row>
            <el-form-item label="成功案例(logo)" prop="successCaseLogoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="successCaseLogoSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDetail"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'successCaseLogoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDetail"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'successCaseLogoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
              <el-switch
                v-model="ruleForm.publishedFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="isDetail"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="审批状态"
              prop="approvalStatus"
              style="text-align:left"
              v-if="dialogType === 'detail'"
            >
              <el-select
                v-model="ruleForm.approvalStatus"
                placeholder="请选择审核状态"
                style="display: block;"
                :disabled="isDetail"
              >
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editOperate" v-if="dialogType === 'edit'">
          修 改
        </el-button>
        <el-button type="primary" @click="createSite" v-if="dialogType === 'add'">确 定</el-button>
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from '../../../components/common-layout.vue';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      approvalStatus: '',
      formApprovalStatus: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10,
        dataType: 1
      },
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      logoSrc: [],
      realImageSrc: [],
      successCaseLogoSrc: [],
      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      orgTypeList: [
        { id: 0, label: 'A' },
        { id: 1, label: 'B' },
        { id: 2, label: 'C' }
      ],
      investmentList: [],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 20,
      dialogFormVisible: false,
      ruleForm: {
        //1投资机构,2金融服务机构,3担保机构
        dataType: 1,
        orgType: null, // 机构类型
        orgTypeName: null, // 机构类型名称
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgDescription: null, // 机构简介
        orgEstablishmentDate: null, // 成立时间
        investmentStage: null, // 投资阶段id
        investmentStageName: null, // 投资阶段name
        orgProvince: null, // 通讯地址-省
        orgCity: null, // 通讯地址-市
        orgDistrict: null, // 通讯地址-区
        orgAddress: null, // 通讯地址-详细地址
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        logoSrc: null, // logo
        realImageSrc: null, // 实景图
        successCaseLogoSrc: null, // 成功案例logo
        publishedFlag: 0, // 是否发布
        approvalStatus: 1,
        investmentAreas: []
      },
      rules: {
        orgName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        orgAbbreviation: [{ required: true, message: '请输入机构简称', trigger: 'blur' }],
        orgDescription: [{ required: true, message: '请输入机构简介', trigger: 'blur' }],
        orgEstablishmentDate: [{ required: true, message: '请选择成立时间', trigger: 'change' }],
        investmentStage: [{ required: true, message: '请选择投资阶段', trigger: 'change' }],
        orgProvince: [{ required: true, message: '请选择机构地址-省', trigger: 'change' }],
        orgCity: [{ required: true, message: '请选择机构地址-市', trigger: 'change' }],
        orgDistrict: [{ required: true, message: '请选择机构地址-区', trigger: 'change' }],
        orgAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        logoSrc: [{ required: true, message: '请上传logo图片', trigger: ['blur', 'change'] }],
        realImageSrc: [{ required: true, message: '请上传实景图', trigger: ['blur', 'change'] }],
        successCaseLogoSrc: [
          { required: true, message: '请上传成功案例logo', trigger: ['blur', 'change'] }
        ],
        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: ['blur', 'change'] }],
        approvalStatus: [
          { required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }
        ],
        // orgType: [{ required: true, message: '请选择机构类型', trigger: ['blur', 'change'] }]
      },
      tableData: [],
      limit: 1,
      showUpload1: false,
      showUpload2: false
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail';
      // return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getData();
    this.getGroup();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    },
    realImageSrc: {
      handler() {
        this.checkLimit(this.realImageSrc, 1);
      }
    }
  },
  methods: {
    orgTypeChange(val) {
      const item = this.orgTypeList.find(item => item.id === val);
      if (item) {
        this.ruleForm.orgTypeName = item.label;
      } else {
        this.ruleForm.orgTypeName = null;
      }
    },
    clearInvest() {
      this.ruleForm.investmentAreas = [];
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        this.getDetail();
      }
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;
          this.successCaseLogoSrc = res.data.successCaseLogoSrc
            ? JSON.parse(res.data.successCaseLogoSrc)
            : [];
          this.realImageSrc = res.data.realImageSrc ? JSON.parse(res.data.realImageSrc) : [];
          this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : [];
          this.ruleForm.investmentStage = Number(this.ruleForm.investmentStage)
          this.ruleForm.investmentAreas = res.data.investmentAreas
            ? JSON.parse(res.data.investmentAreas)
            : [];
          // if(res.data.realImageSrc) {
          // 	this.realImageSrc.push(res.data.realImageSrc)
          // }
          // if(res.data.logoSrc) {
          // 	this.logoSrc.push(res.data.logoSrc)
          // }

          // this.ruleForm.investmentAreas =
          // res.data.investmentAreas && res.data.investmentAreas.length > 0 ? res.data.investmentAreas.map(Number) : [];
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getData() {
      console.log('this.listQuery.approvalStatus', this.listQuery.approvalStatus);
      if (this.listQuery.approvalStatus === null) {
        this.$delete(this.listQuery, 'approvalStatus');
      }
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/finance/investment-firms/page',
          this.listQuery
        )
        .then(res => {
          if (res.code == 0) {
            let arr = res.data.data;
            arr.forEach(item => {
              if (item.logoSrc) {
                item.imgSrc = JSON.parse(item.logoSrc)[0].url;
              } else {
                item.imgSrc = '';
              }
            });
            this.tableData = arr;
            // this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_institution_category', 'financial_investment_stage']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            console.log('response', response);
            this.orgTypeList = response.data.financial_institution_category;
            this.investmentList = response.data.financial_investment_stage;
            // this.ruleForm = response.data
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this['showUpload' + (index + 1)] = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this['showUpload' + (index + 1)] = false;
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          // 审核-退回的担保机构，修改重置为待审核
          if (this.ruleForm.approvalStatus === 3) {
            this.ruleForm.approvalStatus = 1;
          }
          this.ruleForm.investmentAreas =
            this.ruleForm.investmentAreas.length > 0
              ? JSON.stringify(this.ruleForm.investmentAreas)
              : '[]';
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/update`, {
              ...this.ruleForm,
              dataType: 1
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    searchSelect(e) {
      if (e) {
        this.listQuery.approvalStatus = e;
        this.getData();
      } else {
        this.$delete(this.listQuery, 'approvalStatus');
        this.getData();
      }
    },
    resetData() {
      this.ruleForm = {
        //1投资机构,2金融服务机构,3担保机构
        dataType: 1,
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgDescription: null, // 机构简介
        orgEstablishmentDate: null, // 成立时间
        investmentStage: null, // 投资阶段id
        investmentStageName: null, // 投资阶段name
        orgProvince: null, // 通讯地址-省
        orgCity: null, // 通讯地址-市
        orgDistrict: null, // 通讯地址-区
        orgAddress: null, // 通讯地址-详细地址
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        logoSrc: null, // logo
        realImageSrc: null, // 实景图
        successCaseLogoSrc: null, // 成功案例logo
        publishedFlag: 0, // 是否发布
        approvalStatus: 1
      };
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.logoSrc = [];
      this.realImageSrc = [];
      this.successCaseLogoSrc = [];
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.ruleForm.investmentAreas =
            this.ruleForm.investmentAreas.length > 0
              ? JSON.stringify(this.ruleForm.investmentAreas)
              : '[]';
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/create`, {
              ...this.ruleForm,
              dataType: 1
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功');
                this.dialogFormVisible = false;
                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .rowItem1 {
    float: left;
  }
}
</style>
